import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Message } from "semantic-ui-react";
import { notificationDelete } from "../../actions/notificationActions";
const Notifier = () => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications);

  return (
    <div
      style={{ position: "absolute", top: "4rem", width: "40%", left: "30%" }}
    >
      {notifications.ids.map((id) => {
        const ntf = notifications.hash[id];
        const msgType = {};
        msgType[ntf.type] = true;
        return (
          <Message
            key={id}
            {...msgType}
            list={ntf.messages}
            style={{ marginTop: 0, marginBottom: 0 }}
            onDismiss={() => dispatch(notificationDelete(id))}
          />
        );
      })}
    </div>
  );
};

export default Notifier;
